import React from "react";

function NavlogPressureAltitude({
  pressureAltitudeFt,
  densityAltitudeFt,
  fmtFt0,
}) {
  return (
    <>
      <div className="navlog-total-container-density">
        <div className="navlog-total-box-density">
          <span>Field Pressure Altitude:</span>
          <span className="navlog-total-value">
            {fmtFt0(pressureAltitudeFt)}
          </span>
          <span> ft.</span>
        </div>

        <div className="navlog-total-box-density">
          <span>Field Density Altitude:</span>
          <span className="navlog-total-value">
            {fmtFt0(densityAltitudeFt)}
          </span>
          <span> ft.</span>
        </div>
      </div>
    </>
  );
}

export default NavlogPressureAltitude;